import React from "react";

export default function Spacer() {
  return <div className="w-8" />;
}

export function SpacerSmall() {
  return <div className="w-4" />;
}
